package sarka.design.skoria.network

import io.ktor.client.*
import io.ktor.client.plugins.websocket.*
import io.ktor.websocket.*
import kotlinx.coroutines.*
import kotlinx.coroutines.flow.*

class ChatClient(
    private val wsUrl: String = defaultWsUrl(),
    private val httpClient: HttpClient = createPlatformHttpClient()
) {
    private val scope = CoroutineScope(SupervisorJob() + Dispatchers.Default)

    private val _incoming = MutableSharedFlow<String>(extraBufferCapacity = 32)
    val incoming: SharedFlow<String> = _incoming

    private val _connected = MutableStateFlow(false)
    val connected: StateFlow<Boolean> = _connected

    private val _connectionError = MutableSharedFlow<Throwable>(extraBufferCapacity = 1)
    val connectionError: SharedFlow<Throwable> = _connectionError

    private var session: DefaultClientWebSocketSession? = null

    fun connect() {
        scope.launch {
            try {
                // Attach the JWT as a query param so the server can identify the user.
                // (Browsers don't allow custom headers on WebSocket handshakes.)
                val token = TokenStore.token.value
                val url = if (token != null) "$wsUrl?token=$token" else wsUrl

                httpClient.webSocket(urlString = url) {
                    session = this
                    _connected.value = true

                    for (frame in incoming) {
                        if (frame is Frame.Text) {
                            _incoming.emit(frame.readText())
                        }
                    }
                }
            } catch (e: Throwable) {
                _connectionError.tryEmit(e)
            } finally {
                session = null
                _connected.value = false
            }
        }
    }

    fun send(text: String) {
        scope.launch { session?.send(Frame.Text(text)) }
    }

    fun disconnect() {
        scope.launch { session?.close() }
    }

    fun dispose() {
        disconnect()
        scope.cancel()
        httpClient.close()
    }
}
